/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CustomLabel6, CustomLabel8 } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import { InfoCircleFilled } from '@ant-design/icons';
import { Spin, Tooltip } from 'antd';
import { mostrarErro } from '@4beefopag/4bee-fopag-core/dist/molecules';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlarmClock, faCalendarExclamation, faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { colaboradorProps, parametrizacaoProps } from '../../atoms/Props';
import InputWithChangedValue from '../../atoms/Apontamento/InputWithChangedValue';
import { Cell } from '../../atoms/Table';
import NomeColaboradorCell from './NomeColaboradorCell';
import { APONTAMENTO, gravarValorCadastro, PAYROLL_ACTOR_KIND } from '../../../services/apontamentoProducao';
import { shouldBlockUnsignedContract } from '../../../services/util/rule';

function ColaboradorAdiantamento({
  item,
  payrollId,
  isEditable,
  onChangeItemValues,
  parametrizacao,
  createdByActorKind,
}) {
  const { cooperator } = item;
  const showApiValueIndicator = createdByActorKind === PAYROLL_ACTOR_KIND.M2M;

  const isColabBlocked = shouldBlockUnsignedContract(cooperator, parametrizacao) || !cooperator.isEsocialIncluded;

  let icon = <InfoCircleFilled style={{ marginRight: 8 }} />;

  const [loadingHoristaMensalista, setLoadingHoristaMensalista] = useState(false);

  async function alterarHoristaMensalista() {
    if (isEditable) {
      setLoadingHoristaMensalista(true);

      const novoHoristaMensalista =
        item.horistaMensalista === APONTAMENTO.horistaMensalista.mensalista
          ? APONTAMENTO.horistaMensalista.horista
          : APONTAMENTO.horistaMensalista.mensalista;

      onChangeItemValues(item.id, {
        horistaMensalista: novoHoristaMensalista,
      });

      try {
        await gravarValorCadastro(
          payrollId,
          cooperator.id,
          item.hourlyRate,
          cooperator.monthlyEstimate,
          novoHoristaMensalista
        );
      } catch (err) {
        mostrarErro(err);
      }

      setLoadingHoristaMensalista(false);
    }
  }

  if (loadingHoristaMensalista) {
    icon = (
      <Spin
        size="small"
        style={{ marginRight: 8 }}
      />
    );
  } else if (isColabBlocked) {
    const title = !cooperator.isEsocialIncluded
      ? 'Cooperado deve regularizar a pendência do e-social para habilitar a edição'
      : 'Cooperado deve assinar o contrato para habilitar a edição';
    icon = (
      <Tooltip title={title}>
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          size="sm"
          style={{ marginRight: 8, cursor: isEditable ? 'pointer' : 'not-allowed' }}
        />
      </Tooltip>
    );
  } else if (item.horistaMensalista === APONTAMENTO.horistaMensalista.mensalista) {
    icon = (
      <Tooltip title="Mensalista">
        <FontAwesomeIcon
          icon={faCalendarExclamation}
          size="sm"
          style={{
            marginRight: 8,
            cursor: isEditable || cooperator.hasSignedContract === 1 ? 'pointer' : 'not-allowed',
          }}
          onClick={() => alterarHoristaMensalista()}
        />
      </Tooltip>
    );
  } else if (item.horistaMensalista === APONTAMENTO.horistaMensalista.horista) {
    icon = (
      <Tooltip title="Horista">
        <FontAwesomeIcon
          icon={faAlarmClock}
          size="sm"
          style={{ marginRight: 8, cursor: isEditable ? 'pointer' : 'not-allowed' }}
          onClick={() => alterarHoristaMensalista()}
        />
      </Tooltip>
    );
  }

  return (
    <tr key={cooperator.id}>
      <Cell
        fixed
        width="100px"
        left="0px"
      >
        <CustomLabel6>{cooperator.cpf}</CustomLabel6>
      </Cell>
      <NomeColaboradorCell
        colaborador={cooperator}
        icon={icon}
      />
      <td className="variavel-input">
        <InputWithChangedValue
          prefix="R$"
          value={item.variavel}
          originalValue={item.originalValues?.variavel}
          showIndicator={showApiValueIndicator}
          getValue={(variavel) => {
            onChangeItemValues(item.id, {
              variavel,
            });
          }}
          disabled={!isEditable || isColabBlocked}
        />
      </td>
      <td className="reembolso-input">
        <InputWithChangedValue
          prefix="R$"
          value={item.reembolso}
          originalValue={item.originalValues?.reembolso}
          showIndicator={showApiValueIndicator}
          getValue={(reembolso) => {
            onChangeItemValues(item.id, {
              reembolso,
            });
          }}
          disabled={!isEditable || isColabBlocked}
        />
      </td>
      <td className="adiantamento-input">
        <InputWithChangedValue
          prefix="R$"
          value={item.adiantamento}
          originalValue={item.originalValues?.adiantamento}
          showIndicator={showApiValueIndicator}
          getValue={(adiantamento) => {
            onChangeItemValues(item.id, {
              adiantamento,
            });
          }}
          disabled={!isEditable || isColabBlocked}
        />
      </td>
      <td
        className="adiantamento-soma"
        style={{ minWidth: '120px' }}
      >
        <CustomLabel8>{moneyFormat(item.variavel + item.ajudaCusto + item.reembolso + item.adiantamento)}</CustomLabel8>
      </td>
    </tr>
  );
}

ColaboradorAdiantamento.propTypes = {
  item: colaboradorProps,
  onChangeItemValues: PropTypes.func.isRequired,
  payrollId: PropTypes.number.isRequired,
  isEditable: PropTypes.bool.isRequired,
  parametrizacao: parametrizacaoProps,
  createdByActorKind: PropTypes.string,
};

ColaboradorAdiantamento.defaultProps = {
  item: undefined,
  parametrizacao: {},
  createdByActorKind: undefined,
};

export default ColaboradorAdiantamento;
